import { readContract, } from "wagmi/actions";
import { wagmiConfig, } from "@config";
import { Escrow, } from "@contracts";
import { pause, } from "./helpers";
import moment from "moment";
import type { Address, ChainId, TokenDefinition } from "@bracket/addressbook";



export declare type GetUserBalanceProps = {
	chain: ChainId;
	wallet: Address;
	token: TokenDefinition;
	attempt?: number;
	force?: boolean;
}



export const getUserBalance = async ({
	chain,
	wallet,
	token,
	attempt = 0,
	force = false,
}: GetUserBalanceProps): Promise<bigint> => {

	try {

		const now = moment().unix();
		const cached = userBalanceChainedCache[chain].get(token.symbol);

		if(!force) {
			if(cached) {
				const { since, value, } = cached;
				if(now - since < userBalanceTTL) {
					return value;
				}
			}
		}

		const amount = await readContract(wagmiConfig, Escrow.getUserBalance(wallet, token, chain));
		if( typeof amount === "bigint" ) {
			userBalanceChainedCache[chain].set(token.symbol, { since: now, value: amount, });
			return amount;
		}
		throw new Error("getUserBalance returned an invalid data - expected bigint");
	}
	catch( err ) {
		if( attempt < 3 ) {
			await pause(500);
			return await getUserBalance({ chain, wallet, token, attempt: attempt+1, });
		}
		throw new Error(`state::resolvers::getUserBalance failed getting user balance after ${attempt+1} attempts`);
	}
}

const userBalanceChainedCache = {
	1: new Map<TokenDefinition["symbol"], { since: number, value: bigint, }>(),
	18: new Map<TokenDefinition["symbol"], { since: number, value: bigint, }>(),
	188: new Map<TokenDefinition["symbol"], { since: number, value: bigint, }>(),
	42161: new Map<TokenDefinition["symbol"], { since: number, value: bigint, }>(),
	421618: new Map<TokenDefinition["symbol"], { since: number, value: bigint, }>(),
	4216188: new Map<TokenDefinition["symbol"], { since: number, value: bigint, }>(),
}

const userBalanceTTL = 15; // 60 seconds.

